import React from 'react';
import PickerList from './PickerList';
import { TimePickerProps } from './_models';

const TimePickerComponent: React.FC<TimePickerProps> = ({
  hourItems,
  hourValue,
  onHourChange,
  minuteItems,
  minuteValue,
  onMinuteChange,
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center bg-secondary shadow-sm w-100">
      <div className="time-picker">
        <PickerList
          items={hourItems}
          value={hourValue}
          onChange={onHourChange}
        />
        <div className="time-picker-divider">:</div>
        <PickerList
          items={minuteItems}
          value={minuteValue}
          onChange={onMinuteChange}
        />
      </div>
    </div>
  );
};

export default React.memo(TimePickerComponent);
